module.exports = __webpack_public_path__ + "static/media/skeleton_king_head.2edeb7f5.png";